import React from "react";
import styled from "styled-components";
import EulaTermsText from "./EulaTermsText";
import EulaPrivacyText from "./EulaPrivacyText";
import EulaMarketingText from "./EulaMarketingText";

const ViewTermsOfUseText = (props) => {
  const returnText = (target) => {
    let res;
    switch (target) {
      case "eulaTerms":
        res = <EulaTermsText />;
        break;
      case "eulaPrivacy":
        res = <EulaPrivacyText />;
        break;

      case "eulaMarketing":
        res = <EulaMarketingText />;
        break;
      default:
        return "";
    }
    return res;
  };
  return <Wrap>{returnText(props.target)}</Wrap>;
};

export default ViewTermsOfUseText;

const Wrap = styled.div`
  margin-top: 3rem;
  padding-bottom: 3rem;

  h5 {
    margin-top: 1rem;
  }
  ol {
    margin: 0.5rem 0 0 2.5rem;
    list-style: decimal;
    list-style-type: decimal;
  }
  ul {
    margin: 0.5rem 0 0 1rem;
  }
  li {
    font-size: 0.83em;
  }
  p {
    margin-top: 0.5rem;
    font-size: 0.83em;
  }
  table,
  td,
  th {
    border: 1px solid;
    font-size: 0.83em;
  }
  table {
    margin-top: 1rem;
  }
`;
